import { QUERY_KEYS } from '@hub/libs/constants';
import { nextApiCall } from '@hub/libs/nextApiCall';
import type { ProductAssetsFragmentEnhanced, ProductDownloadAssetsQueryEnhanced } from '@hub/models/enhanced-fragments';
import { useQuery } from '@tanstack/react-query';

export const useProductDownloadAssetsQuery = (productId: string, locale: string) =>
  useQuery<ProductAssetsFragmentEnhanced[]>({
    queryKey: [QUERY_KEYS.PRODUCT_DOWNLOAD_ASSETS, productId],
    queryFn: async () => {
      const response = await nextApiCall('product-download-assets', {
        productId,
        locale,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch download assets for ${productId}`);
      }

      const responseObject = (await response.json()) as ProductDownloadAssetsQueryEnhanced;

      if (!responseObject.assets) {
        throw new Error(`Missing download assets for ${productId}`);
      }

      return responseObject.assets;
    },
  });
